<template>
  <v-theme-provider dark>
    <v-row>
      <v-col>

        

        <v-sheet v-show="centers.length > 0">
          <v-row align="center">
            <v-col>
              <!--   <v-tabs  optional>
                            <v-tab v-for="(item, i) in centers" :key="i" @click="chooseCenter" :ripple="false" active-class="text--primary" class="font-weight-bold" min-width="96" text>{{ item.displayName }}</v-tab>
                        </v-tabs>
      -->
              <v-card>
                <v-card-title v-show="selectedCenterId == null">
                  Vælg NEO Center
                </v-card-title>
                <v-list>
                  <v-list-item>
                    <v-list-item-content v-show="selectedCenterId != null">
                      <v-btn
                        @click="selectedCenterId = null"
                        outlined
                      >
                        Skift NEO Center
                      </v-btn>
                    </v-list-item-content>

                    <v-list-item-content>

                      <v-row
                        align="center"
                        justify="space-around"
                      >
                        <v-btn
                          @click="chooseCenter(item.rowKey)"
                          outlined
                          v-for="(item, i) in centers"
                          :key="i"
                          v-show="selectedCenterId == null"
                        >
                          {{item.displayName}}

                        </v-btn>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>

        </v-sheet>
        <v-sheet
          v-if="selectedCenterId"
          class="text-center"
        > {{selectedCenter.name}} - {{selectedCenter.address}}, {{selectedCenter.zip}} {{selectedCenter.city}}, Tlf. <a
            style="color:#fff;"
            :href="'tel:'+selectedCenter.phone"
          >{{selectedCenter.phone}}</a>, email: <a
            style="color:#fff;"
            :href="'mailto:'+selectedCenter.email"
          >{{selectedCenter.email}}</a>
        </v-sheet>
        <v-sheet
          height="64"
          v-show="selectedCenterId"
        >
          <v-toolbar flat>
            <v-btn
              outlined
              small
              class="mr-2"
              @click="setToday"
            >
              I dag
            </v-btn>
            <v-btn
              fab
              small
              outlined
              @click="prev"
              class="mr-1"
            >
              <v-icon small>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              fab
              small
              outlined
              @click="next"
              class="mr-2"
            >
              <v-icon small>mdi-chevron-right</v-icon>
            </v-btn>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="focus"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  class="mr-1"
                >Vælg dato</v-btn>
              </template>
              <v-date-picker
                v-model="focus"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(date)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
            <v-spacer></v-spacer>
            <div
              small
              v-if="$refs.calendar"
              class="mr-1"
            >{{ $refs.calendar.title }}</div>

          </v-toolbar>
        </v-sheet>
        <v-sheet v-show="selectedCenterId">
          <v-calendar
            ref="calendar"
            :now="today"
            v-model="focus"
            :value="today"
            :events="events"
            color="primary"
            :event-color="getEventColor"
            weekdays="1,2,3,4,5,6,0"
            @change="calendarFechEvents"
            type="week"
            :first-interval="dayStart"
            interval-minutes="60"
            locale="da-DK"
            :interval-count="intervalCount"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @mousedown:event="startDrag"
            @mousedown:time="startTime"
            @mousemove:time="mouseMove"
            @mouseup:time="endDrag"
            @mouseleave.native="cancelDrag"
          ></v-calendar>
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
          >
            <v-card
              color=""
              min-width="350px"
              flat
              v-show="(isAdmin() || isCenterAdmin())"
            >
              <v-toolbar
                color="red lighten-1"
                dark
              >
                <v-toolbar-title>CenterAdmin</v-toolbar-title>
              </v-toolbar>
              <v-card-text class="text--primary">

                <v-text-field
                  v-model="selectedEvent.spots"
                  type="number"
                  label="Max ledige pladser"
                ></v-text-field>

              </v-card-text>
              <v-card-text
                class="text--primary"
                v-show="isSuperAdmin()"
              >
                <div>
                  <v-checkbox
                    v-model="debug"
                    :label="`Debug info`"
                  ></v-checkbox>
                  <pre v-show="debug">
                                {{selectedEvent}}</pre>
                </div>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  text
                  color="secondary"
                  outlined
                  @click="saveSchedule(selectedEvent)"
                >
                  Gem
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-card
              color="grey lighten-4"
              min-width="350px"
              flat
            >
              <v-toolbar
                :color="selectedEvent.color"
                dark
              >

                <v-toolbar-title>{{selectedEvent.start | fullDateTimeWithKl}}</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn
                  icon
                  @click="selectedOpen = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-title>
                {{selectedEvent.name}}
              </v-card-title>
              <!--  <v-card-text>
                            <pre>{{selectedEvent}}</pre>
                        </v-card-text>
                        -->

              <v-card-text
                class="text--primary"
                v-show="(isAdmin() || isCenterAdmin()) && (selectedEvent.bookings != null && selectedEvent.bookings.length > 0)"
              >

                <div>Tilmeldte:</div>
                <div
                  v-show="isAdmin() || isCenterAdmin()"
                  v-for="booking in selectedEvent.bookings"
                  :key="booking.rowKey"
                >

                  {{booking.created | fullDateTime}}, {{booking.title}}
                  <br>
                  <div
                    v-for="(guest, index) in booking.guests"
                    :key="index"
                  >Gæst : {{guest}} </div>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  outlined
                  v-show="isAdmin() || isCenterAdmin()"
                  text
                  color="secondary"
                  :disabled="disableDeleteOnSelected(selectedEvent)"
                  @click="deleteSelected(selectedEvent)"
                >
                  Slet
                </v-btn>
                <v-btn
                  outlined
                  v-show="selectedEvent.state != 'Full' && !selectedEvent.booked && selectedEvent.bookable"
                  text
                  color="secondary"
                  @click="showBookDialog(selectedEvent)"
                >
                  Book nu
                </v-btn>
                <v-btn
                  outlined
                  v-show="selectedEvent.booked"
                  text
                  color="secondary"
                  @click="cancelSelected(selectedEvent)"
                >
                  Aflys min tid
                </v-btn>

              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>

        <v-dialog
          v-model="bookDialog"
          dark
          persistent
          max-width="290"
          color="#294B43"
        >
          <v-card>
            <v-card-title class="headline">
              Vil du booke tiden {{selectedEvent.start | fullDateTimeWithKl}}?
            </v-card-title>
            <v-card-text>

              <v-checkbox
                v-model="addGuests"
                :label="`Har du gæster med ?`"
              ></v-checkbox>
              <v-text-field
                v-show="addGuests"
                :label="`Gæst ${index+1}`"
                v-model="selectedEvent.guests[index]"
                v-for="(guest, index) in selectedEvent.guests"
                :key="`g-${index}`"
              ></v-text-field>

              <v-fab-transition>
                <v-btn
                  v-show="addGuests"
                  color="pink"
                  dark
                  top
                  right
                  fab
                  @click="addGuest()"
                  :disabled="!canAdd()"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="bookSelected()"
              >
                Book nu
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                @click="bookDialog = false"
              >
                Annuler
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-snackbar
          v-model="showSnackbar"
          :multi-line="false"
          :timeout="snackbarTimeout"
          dark
          :color="snackbarColor"
        >
          {{ snackbarText }}
          <v-btn
            outlined
            color="white"
            text
            @click="showSnackbar = false"
          >Luk</v-btn>
        </v-snackbar>
      </v-col>
    </v-row>

  </v-theme-provider>
</template>

<script>
import router from "./../../router";
import store from "./../../store";
import core from "./../../mixins/core";

export default {
  name: "SectionNews",
  mixins: [core],
  data: () => ({
    debug: false,
    addGuests: false,
    dayStart: 9,
    bookDialog: false,
    intervalCount: 8,
    menu: false,
    today: null,
    events: [],
    focus: "",
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    dragEvent: null,
    dragStart: null,
    createEvent: null,
    createStart: null,
    extendOriginal: null,
    centers: [],
    selectedCenter: null,
    selectedCenterId: null,
    selectedRoom: null,
    snackbarText: "",
    snackbarColor: "#EE765E",
    snackbarTimeout: 5000,
    showSnackbar: false,
  }),

  methods: {
    addGuest() {
      if (this.selectedEvent.spots != undefined)
        this.selectedEvent.guests.push("");
    },
    canAdd() {
      if (this.selectedEvent.spots != undefined) {
        if (this.isCenterAdmin()) return true;
        return (
          this.selectedEvent.particpants + this.selectedEvent.guests.length <
          this.selectedEvent.spots - 1
        ); // 1 is the user
      }
    },
    toast(message, error) {
      this.snackbarColor = "#EE765E";
      this.snackbarColor = "success";

      this.snackbarTimeout = 10000;

      if (error == true) {
        this.snackbarColor = "error";
        this.snackbarTimeout = 20000;
      }
      this.showSnackbar = true;
      this.snackbarText = message;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    getCenters() {
      var c = [];
      this.fetchVisibleCenters().then((result) => {
        result.forEach((center) => {
          c.push({
            displayName: center.name + " (" + center.zip + ")",
            name: center.name,
            address: center.address,
            address2: center.address2,
            zip: center.zip,
            city: center.city,
            phone: center.contactPhone,
            email: center.contactEmail,
            rowKey: center.rowKey,
            roomId: center.rooms.length > 0 ? center.rooms[0].rowKey : null,
            scheduleHours: center.rooms[0].scheduleHours,
            roomWeekHours: center.rooms[0].roomWeekHours,
          });
        });
        this.centers = c;
        store.commit("setCenters", c);
      });
    },
    getEventColor(event) {
      if (!event.bookable) return "gray";
      switch (event.state) {
        case "Available":
          return "#68B600";
        case "PartlyAvailable":
          return "#579900";
        case "Assigned":
          return "#1B5A6F";
        case "Reserved":
          return "blue";
        case "Full":
          return "#934c4e";
        case "Occupied":
          return "red";
        default:
          return "white";
      }
    },

    calendarFechEvents({ start }) {
      this.fetchEvents(start.date);
    },
    fetchEvents(start) {
      if (this.selectedRoom != null) {
        if (start == undefined && this.focus != "") start = this.focus;
        this.fetchRoomSchedules(
          this.selectedRoom,
          this.$store.getters.currentUser.rowKey,
          start
        ).then((result) => {
          if (Array.isArray(result)) {
            result.forEach((time) => {
              time.start = this.$moment(time.start).format("YYYY-MM-DD HH:mm");
              time.end = this.$moment(time.end).format("YYYY-MM-DD HH:mm");
              if (time.guests == undefined) time.guests = [];
            });
            this.events = result;
          } else this.events = [];
        });
      }
    },

    chooseCenter(centerId) {
      this.selectedCenterId = centerId;
      this.user = user;

      var center = this.centers.find((res) => {
        return res.rowKey === centerId;
      });
      this.selectedCenter = center;

      store.commit("setCurrentCenter", center);

      (this.dayStart = center.roomWeekHours.openningHour),
        (this.intervalCount = center.roomWeekHours.closingHour - this.dayStart);

      var user = store.getters.currentUser;

      if (
        user.roles == "Admin" ||
        user.roles == "CenterAdmin" ||
        user.familyMember == true ||
        user.ambassador == true
      ) {
        (this.dayStart = 6), (this.intervalCount = 22 - 6);
      }

      if (this.isCenterAdmin()) {
        this.toast(
          "Som center administrator kan du administrere kalenderen i dette center"
        );
      }
      this.selectedRoom = center.roomId;

      this.fetchEvents(this.$moment().format());
    },
    deleteSelected(selectedEvent) {
      this.deleteSchedule(selectedEvent.rowKey).then(() => {
        this.fetchEvents();
        this.selectedOpen = false;
      });
    },
    disableDeleteOnSelected(selectedEvent) {
      if (selectedEvent.bookings == undefined) return false;
      return selectedEvent.bookings.length > 0;
    },
    bookSelected() {
      if (!this.addGuests) {
        this.selectedEvent.guests = [];
      }
      this.bookSchedule(
        this.selectedEvent.rowKey,
        this.selectedEvent.guests
      ).then(() => {
        this.fetchEvents();
        this.selectedOpen = false;
        this.bookDialog = false;
      });
    },
    showBookDialog(selectedEvent) {
      this.bookDialog = true;
      if (selectedEvent.guests == undefined) selectedEvent.guests = [];

      this.selectedEvent = selectedEvent;
    },
    saveSchedule(selectedEvent) {
      this.updateSchedule(selectedEvent).then(() => {
        this.fetchEvents();
        this.selectedOpen = false;
      });
    },

    cancelSelected(selectedEvent) {
      if (selectedEvent.cancelable) {
        this.cancelSchedule(selectedEvent.rowKey).then(() => {
          this.fetchEvents();
          this.selectedOpen = false;
        });
      } else {
        this.toast(
          "Du kan ikke aflyse hvis der er mindre end 1 dag til aftalen"
        );
      }
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.addGuests = false;
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    startDrag({ event, timed }) {
      if (event && timed) {
        this.dragEvent = event;
        this.dragTime = null;
        this.extendOriginal = null;
      }
    },
    mouseMove(tms) {
      const mouse = this.toTime(tms);

      if (this.dragEvent && this.dragTime !== null) {
        const start = this.dragEvent.start;
        const end = this.dragEvent.end;
        const duration = end - start;
        const newStartTime = mouse - this.dragTime;
        const newStart = this.roundTime(newStartTime);
        const newEnd = newStart + duration;

        this.dragEvent.start = newStart;
        this.dragEvent.end = newEnd;
      } else if (this.createEvent && this.createStart !== null) {
        const mouseRounded = this.roundTime(mouse, false);
        const min = Math.min(mouseRounded, this.createStart);
        const max = Math.max(mouseRounded, this.createStart);

        this.createEvent.start = min;
        this.createEvent.end = max;
      }
    },
    startTime(tms) {
      const mouse = this.toTime(tms);

      if (this.dragEvent && this.dragTime === null) {
        const start = this.dragEvent.start;

        this.dragTime = mouse - start;
      } else {
        this.createStart = this.roundTime(mouse);
        this.createEvent = {
          name: `Event #${this.events.length}`,
          color: "green",
          start: this.createStart,
          end: this.createStart,
          timed: true,
        };
        //

        if (this.selectedCenterId == null) return;
        if (this.isAdmin() || this.isCenterAdmin())
          this.addSchedule(
            this.selectedRoom,
            this.$moment(this.createStart)
          ).then(() => {
            this.fetchEvents();
          });
        // this.events.push(this.createEvent)
      }
    },
    endDrag() {
      this.dragTime = null;
      this.dragEvent = null;
      this.createEvent = null;
      this.createStart = null;
      this.extendOriginal = null;
    },
    roundTime(time, down = true) {
      const roundTo = 15; // minutes
      const roundDownTime = roundTo * 60 * 1000;

      return down
        ? time - (time % roundDownTime)
        : time + (roundDownTime - (time % roundDownTime));
    },
    cancelDrag() {
      if (this.createEvent) {
        if (this.extendOriginal) {
          this.createEvent.end = this.extendOriginal;
        } else {
          const i = this.events.indexOf(this.createEvent);
          if (i !== -1) {
            this.events.splice(i, 1);
          }
        }
      }

      this.createEvent = null;
      this.createStart = null;
      this.dragTime = null;
      this.dragEvent = null;
    },
    toTime(tms) {
      return new Date(
        tms.year,
        tms.month - 1,
        tms.day,
        tms.hour,
        tms.minute
      ).getTime();
    },
  },
  created: function () {
    this.getCenters();
  },

  mounted: function () {
    this.today = this.$moment(new Date()).format("YYYY-MM-DD hh:mm");
    this.focus = this.today;
    //   this.$refs.calendar.scrollToTime('11:00')

    if (!this.isUserDetailsValid(store.getters.currentUser)) {
      router.push({
        name: "Profile",
        params: {
          fillOutName: true,
        },
      });
      //   EventBus.$emit('updateUser');
    }
  },

  provide: {
    heading: {
      align: "center",
    },
  },
};
</script>
